import { createApi } from '@reduxjs/toolkit/query/react';
import { pensionBaseQuery } from '../../lib/axiosBaseQuery';
import { paramBuilder } from '../../utils/common';

export const beneficiariesApi = createApi({
  reducerPath: 'beneficiariesApi',
  baseQuery: pensionBaseQuery,
  tagTypes: ['BeneficiaryList', 'BeneficiaryDetail'],
  endpoints: (builder) => ({
    getBeneficiariesList: builder.query<any, void>({
      query: () => ({
        url: `api/v1/pension/Beneficiary/list`,
        method: 'GET',
      }),
      providesTags: ['BeneficiaryList'],
    }),
    getBeneficiaries: builder.query<any, { id: string; page?: number; pageSize?: number }>({
      query: ({ id, page = 1, pageSize = 500 }) => ({
        url: `api/v1/pension/Beneficiary/${id}/details`,
        method: 'GET',
        params: { page, pageSize },
      }),
      providesTags: (result, error, { id }) => [{ type: 'BeneficiaryDetail', id }],
    }),
    addBeneficiary: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: `api/v1/pension/Beneficiary/add`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['BeneficiaryList'],
    }),
    updateBeneficiary: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: `api/v1/pension/Beneficiary/update`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['BeneficiaryList', 'BeneficiaryDetail'],
    }),
    deleteBeneficiaryList: builder.mutation<any, string>({
      query: (id) => ({
        url: `api/v1/pension/Beneficiary/remove/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BeneficiaryList'],
    }),
    deleteBeneficiaryItem: builder.mutation<any, string>({
      query: (id) => ({
        url: `api/v1/pension/Beneficiary/item/${id}/remove`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BeneficiaryList', 'BeneficiaryDetail'],
    }),
  }),
});

export const {
  useGetBeneficiariesListQuery,
  useGetBeneficiariesQuery,
  useLazyGetBeneficiariesQuery,
  useAddBeneficiaryMutation,
  useUpdateBeneficiaryMutation,
  useDeleteBeneficiaryListMutation,
  useDeleteBeneficiaryItemMutation,
} = beneficiariesApi;
